import { inject, Pipe, PipeTransform } from '@angular/core';
import { IconProviderService } from '../../../whitelabel/services/icon-provider.service';
import { FileTypeIconPipe } from '../../../shared/pipes/file-type-icon.pipe';
import { ViewReportDefinition } from '../contract/view-report-definition.contract';
import { IconKey } from '../../../../whitelabel/icon-key.enum';

const FONT_AWESOME_STYLE_CLASS = /^(fa-(solid|regular|light|thin|duotone|brands)|fa[slrtdb])$/;
const FONT_AWESOME_ICON_CLASS = /^fa-[\w-]+$/;

@Pipe({
  name: 'getReportIcon',
  standalone: true,
})
export class GetReportIconPipe implements PipeTransform {
  private readonly iconProviderService = inject(IconProviderService);
  private readonly fileTypeIconPipe = inject(FileTypeIconPipe);

  private readonly isFontAwesome = (iconKey: string): boolean => {
    if (!iconKey) return false;
    const [styleClass, iconClass, ...rest] = iconKey.split(/\s+/);
    if (rest.length > 0) return false;
    return iconClass === undefined
      ? FONT_AWESOME_ICON_CLASS.test(styleClass)
      : FONT_AWESOME_STYLE_CLASS.test(styleClass) && FONT_AWESOME_ICON_CLASS.test(iconClass);
  };

  transform(report: ViewReportDefinition): string {
    const iconKey = report.reportDefinitionIconKey;

    if (!iconKey) {
      return this.fileTypeIconPipe.transform(report.reportDefinitionExportFormat);
    }

    return this.isFontAwesome(iconKey) ? iconKey : this.iconProviderService.getIcon(IconKey.ReportCardDefaultIcon);
  }
}
